import { Person } from 'entities/person';
import { FC } from 'react';
import { formatWithLocale } from 'shared/lib/datepicker';
import { Typography } from 'shared/ui/typography';

interface PersonLastVisitProps {
	person: Person;
}

export const PersonLastVisit: FC<PersonLastVisitProps> = ({ person }) => {
	return (
		<>
			{person.dt_last_visit && (
				<>
					<Typography pointer={true}>Последний визит</Typography>
					<Typography isBold={true} pointer={true}>
						{formatWithLocale(
							new Date(person.dt_last_visit),
							'dd.MM.yyyy',
						)}
					</Typography>
				</>
			)}
		</>
	);
};
